<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2026-06-17 19:42:44
 * @LastEditors: hl
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/purchase/components/OrderPrice/index.vue
 -->
<template>
  <!-- 订单详情价格与配送服务、留言一体化卡片 -->
  <div class="det_price">
    <!-- 配送服务（增值服务）选择 -->
    <div
      v-if="$appSource === 3 && preCheckout.valueAddedServices && preCheckout.valueAddedServices.length > 0"
      class="delivery_section"
    >
      <div
        class="order_id font12 font_weight500 colo087 line_height_17 text_left padding_b8"
        @click="$emit('openServicePopup')"
      >
        <div>配送服务</div>
        <div class="delivery_right">
          <span class="delivery_freight">运费 {{ $G("symbol") }}{{ preCheckout.freight || '0.00' }}</span>
          <van-icon name="arrow" class="delivery_arrow" />
        </div>
      </div>
      <div class="delivery_tip" @click="$emit('openServicePopup')">
        包裹做标记，添加额外打包材料等服务，请点击这里进行选择
      </div>
      <div class="delivery_divider"></div>
    </div>

    <!-- 买家留言 -->
    <div
      class="order_id font12 font_weight500 colo087 line_height_17 text_left"
      @click="$emit('goNote')"
    >
      <div>买家留言</div>
      <div class="colo038 flex_align_center">
        <span :class="{ colo087: note }" class="ms">{{ note || "建议提前和卖家协商" }}</span>
        <van-icon name="arrow" class="arrow_icon" />
      </div>
    </div>

    <div
      class="order_id font12 font_weight500 colo087 line_height_17 text_left"
    >
      <div>商品总额</div>
      <div>{{ preCheckout.price | currency(false) }}</div>
    </div>
    <div
      class="order_id font12 font_weight500 colo087 line_height_17 text_left"
    >
      <div>税率费用</div>
      <div>{{ preCheckout.tax | currency(false) }}</div>
    </div>
    <div
      v-if="$appSource === 3 && preCheckout.valueAddedServiceAmount && preCheckout.valueAddedServiceAmount > 0"
      class="order_id font12 font_weight500 colo087 line_height_17 text_left"
    >
      <div>
        贴心服务
        <span v-if="valueAddedServiceDetails" class="service_details_text">{{ valueAddedServiceDetails }}</span>
      </div>
      <div>{{ preCheckout.valueAddedServiceAmount | currency(false) }}</div>
    </div>
    <div
      class="order_id font12 font_weight500 colo087 line_height_17 text_left"
    >
      <div>运费</div>
      <div v-if="preCheckout.freight">
        {{ preCheckout.freight | currency(false) }}
      </div>
      <div v-if="!preCheckout.freight">免运费</div>
    </div>
    <div
      v-if="false"
      class="order_id font12 font_weight500 colo087 line_height_17 text_left"
    >
      <div>活动扣减</div>
      <div>-¥30</div>
    </div>
    <div
      v-if="preCheckout.discountMoney"
      class="order_id font12 font_weight500 colo087 line_height_17 text_left"
    >
      <div>优惠券</div>
      <div>{{ preCheckout.discountMoney | currency(false) }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    note: {
      type: String,
      default: ""
    }
  },
  computed: {
    preCheckout() {
      return this.$store.getters.preCheckout;
    },
    valueAddedServiceDetails() {
      const services = this.preCheckout.valueAddedServices || [];
      const selectedNames = services
        .filter(e => e.selected)
        .map(e => {
          let n = e.name || '';
          if (n && !n.startsWith('+')) {
            n = '+ ' + n;
          }
          return n + ';';
        })
        .join('');
      return selectedNames ? ' [' + selectedNames + ']' : '';
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
.det_price {
  background: #fff;
  margin-top: 12px;
  padding: 24px 12px 0;
  .order_id {
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding-bottom: 24px;
    cursor: pointer;
  }
  .padding_b8 {
    padding-bottom: 8px !important;
  }
  .delivery_tip {
    border: 1px solid #bf9264;
    border-radius: 4px;
    padding: 6px 10px;
    font-size: 11px;
    color: #bf9264;
    background-color: rgba(191, 146, 100, 0.05);
    line-height: 1.4;
    margin-bottom: 12px;
    text-align: left;
    cursor: pointer;
  }
  .delivery_divider {
    height: 1px;
    background-color: rgba(0, 0, 0, 0.05);
    margin-bottom: 16px;
  }
  .flex_align_center {
    display: flex;
    align-items: center;
  }
  .arrow_icon {
    font-size: 14px;
    color: #ccc;
    margin-left: 4px;
  }
  .delivery_right {
    display: flex;
    align-items: center;
    color: #858585;
    .delivery_freight {
      margin-right: 4px;
    }
    .delivery_arrow {
      font-size: 14px;
      color: #ccc;
    }
  }
  .service_details_text {
    font-size: 10px;
    color: #bf9264;
    font-weight: 400;
    margin-left: 4px;
  }
}
</style>
